/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  OAuthTokenRevokeReq,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    OAuthTokenRevokeReqFromJSON,
    OAuthTokenRevokeReqToJSON,
} from '../models';

export interface PostSsoOidcTokensRevokeRequest {
    oAuthTokenRevokeReq: OAuthTokenRevokeReq;
    slashIDSdkVersion?: string;
}

/**
 * 
 */
export class SSOApi extends runtime.BaseAPI {

    /**
     * Revoke a previously obtained OAuth access or refresh token for an IdP. This endpoint is deprecated. Please use /sso/oidc/tokens/revoke/v2 instead. 
     * (Deprecated) Revoke an OAuth token obtained through SSO with OIDC
     */
    async postSsoOidcTokensRevokeRaw(requestParameters: PostSsoOidcTokensRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.oAuthTokenRevokeReq === null || requestParameters.oAuthTokenRevokeReq === undefined) {
            throw new runtime.RequiredError('oAuthTokenRevokeReq','Required parameter requestParameters.oAuthTokenRevokeReq was null or undefined when calling postSsoOidcTokensRevoke.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sso/oidc/tokens/revoke`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthTokenRevokeReqToJSON(requestParameters.oAuthTokenRevokeReq),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Revoke a previously obtained OAuth access or refresh token for an IdP. This endpoint is deprecated. Please use /sso/oidc/tokens/revoke/v2 instead. 
     * (Deprecated) Revoke an OAuth token obtained through SSO with OIDC
     */
    async postSsoOidcTokensRevoke(requestParameters: PostSsoOidcTokensRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postSsoOidcTokensRevokeRaw(requestParameters, initOverrides);
    }

}
